import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { fetchNewsList, mediaUrl } from '../api/news';

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetchNewsList()
      .then((items) => {
        if (alive) setNews(items);
      })
      .catch(() => {
        if (alive) setNews([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  const featured = news.slice(0, 3);

  return (
    <section id="news" className="py-24 px-6 bg-[#f5f5f3]">
      <div className="max-w-[1300px] mx-auto">
        <div className="text-center mb-16">
          <p
            className="text-[#C99A36] tracking-[0.4em] text-[12px] font-semibold mb-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            SETA NEWS
          </p>
          <h2
            className="text-[#1a1a1a] text-[36px] md:text-[44px] font-bold tracking-tight lowercase"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            news
          </h2>
          <div className="mx-auto mt-4 w-24 h-[3px] bg-[#C99A36]" />
        </div>

        {loading ? (
          <p className="text-center text-[#888] text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Carregando matérias…
          </p>
        ) : featured.length === 0 ? (
          <p className="text-center text-[#888] text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Nenhuma matéria publicada no momento.
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {featured.map((n) => (
              <Link
                key={n.id}
                to={`/news/${n.slug}`}
                className="group bg-white shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer block"
              >
                <div className="overflow-hidden h-[220px]">
                  <img
                    src={mediaUrl(n.image)}
                    alt={n.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <h3
                    className="text-[#1a1a1a] font-bold text-[16px] tracking-wide mb-3 group-hover:text-[#C99A36] transition-colors"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {n.title}
                  </h3>
                  <p
                    className="text-[#555] text-[13px] leading-[1.7] mb-4 line-clamp-3"
                    style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                  >
                    {n.excerpt}
                  </p>
                  <div
                    className="flex items-center gap-4 text-[11px] text-[#888] tracking-wide"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    <span className="flex items-center gap-1">
                      <Calendar size={12} /> {n.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <Clock size={12} /> {n.readTime}
                    </span>
                  </div>
                  <div
                    className="mt-5 flex items-center gap-2 text-[#C99A36] text-[12px] font-semibold tracking-[0.2em] opacity-0 group-hover:opacity-100 transition-opacity"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    LER MAIS <ArrowRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {news.length > 3 && (
          <div className="mt-14 text-center">
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-8 py-3 bg-[#1a1a1a] text-white text-[12px] tracking-[0.25em] font-semibold hover:bg-[#C99A36] transition-colors duration-300"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              VER TODAS AS MATÉRIAS <ArrowRight size={14} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default News;
